import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["segmentCriteria", "enrollmentFilters", "goalCriteria", "reEnrollmentTriggerSets", "suppressionListIds", "unenrollmentSetting", "goalFilters"],
  _excluded2 = ["segmentCriteria", "enrollmentFilters", "goalCriteria", "reEnrollmentTriggerSets", "suppressionListIds", "unenrollmentSetting"];
import { List } from 'immutable';
import UnenrollmentSetting from 'automation-ui-canvas/flow/records/properties/UnenrollmentSetting';
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
export const ClassicEnrollmentSettingsKeys = {
  ALLOW_CONTACT_TO_TRIGGER_MULTIPLE_TIMES: 'allowContactToTriggerMultipleTimes',
  ALLOW_ENROLLMENT_FROM_MERGE: 'allowEnrollmentFromMerge',
  CAN_ENROLL_FROM_SALESFORCE: 'canEnrollFromSalesforce',
  DESCRIPTION: 'description',
  ENROLLMENT_FILTERS: 'enrollmentFilters',
  ENROLL_ON_CRITERIA_UPDATE: 'enrollOnCriteriaUpdate',
  EVENT_ANCHOR: 'eventAnchor',
  GOAL_CRITERIA: 'goalCriteria',
  INTERNAL_GOAL_LIST_ID: 'internalGoalListId',
  INTERNAL_STARTING_LIST_ID: 'internalStartingListId',
  LISTENING: 'listening',
  RECUR_ANNUALLY: 'recurAnnually',
  REENROLLMENT_TRIGGER_SETS: 'reEnrollmentTriggerSets',
  SEGMENT_CRITERIA: 'segmentCriteria',
  SUPPRESSION_LIST_IDS: 'suppressionListIds',
  UNENROLLMENT_SETTING: 'unenrollmentSetting',
  WORKFLOW_ID: 'workflowId'
};
export default class ClassicEnrollmentSettings extends createImmutableObjectClass({
  allowContactToTriggerMultipleTimes: false,
  allowEnrollmentFromMerge: false,
  canEnrollFromSalesforce: false,
  description: null,
  enrollmentFilters: [],
  enrollOnCriteriaUpdate: false,
  eventAnchor: null,
  goalCriteria: [],
  internalGoalListId: null,
  internalStartingListId: null,
  listening: false,
  recurAnnually: false,
  reEnrollmentTriggerSets: [],
  segmentCriteria: [],
  suppressionListIds: [],
  unenrollmentSetting: {},
  workflowId: null
}, {
  fromJSON: _ref => {
    let {
        segmentCriteria,
        enrollmentFilters,
        goalCriteria,
        reEnrollmentTriggerSets,
        suppressionListIds,
        unenrollmentSetting
        // TODO: Come back to this and remove it from model
        // @ts-expect-error not defined on type
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return Object.assign({}, rest, {
      segmentCriteria: List(segmentCriteria || []),
      enrollmentFilters: List(enrollmentFilters || []),
      goalCriteria: List(goalCriteria || []),
      reEnrollmentTriggerSets: List(reEnrollmentTriggerSets || []),
      suppressionListIds: List(suppressionListIds || []),
      unenrollmentSetting: new UnenrollmentSetting(unenrollmentSetting || {}),
      enrollOnCriteriaUpdate: false // deprecating
    });
  },
  toJSON: _ref2 => {
    let {
        segmentCriteria,
        enrollmentFilters,
        goalCriteria,
        reEnrollmentTriggerSets,
        suppressionListIds,
        unenrollmentSetting
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return Object.assign({}, rest, {
      segmentCriteria: segmentCriteria.toJS(),
      enrollmentFilters: enrollmentFilters.toJS(),
      goalCriteria: goalCriteria.toJS(),
      reEnrollmentTriggerSets: reEnrollmentTriggerSets.toJS(),
      suppressionListIds: suppressionListIds.toJS(),
      unenrollmentSetting: unenrollmentSetting.toJS(),
      enrollOnCriteriaUpdate: false // deprecating
    });
  }
}) {
  setEnrollmentFilters(enrollmentFilters) {
    return this.set('enrollmentFilters', enrollmentFilters);
  }
  getSegmentCriteria() {
    return this.segmentCriteria;
  }
  getEnrollmentFilters() {
    return this.enrollmentFilters;
  }
  getReenrollmentTriggerSets() {
    return this.reEnrollmentTriggerSets;
  }
  getUnenrollmentSetting() {
    return this.unenrollmentSetting; // We can cast here since we always overwrite the default value in the constructor
  }
  getListeningSetting() {
    return this.listening;
  }
  getAllowEnrollmentFromMergeSetting() {
    return this.allowEnrollmentFromMerge;
  }
  getSuppressionListIds() {
    return this.suppressionListIds;
  }
}